import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Prompt',
  sub: 'your instruction',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'AI',
  sub: 'ChatGPT · Claude · Gemini',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Result',
  sub: 'court-ready report',
  tone: 'bg-white text-plum border-blush/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-240" data-mp="2zjfro6nf7m6v">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-241" data-mp="34gpnc41eku35" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-52 ${n.tone}`} data-id="element-242" data-mp="156psb9ea9ks3">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-243" data-mp="1a62gpyksyzws">
              <n.icon className="h-5 w-5" data-id="element-244" data-mp="1f0idg6w3y6i5" />
            </span>
            <div className="min-w-0" data-id="element-245" data-mp="1a9a1p47b291t">
              <p className="font-display text-base font-black" data-id="element-246" data-mp="1a88gi6wks66d">{n.label}</p>
              <p className="truncate text-xs opacity-70" data-id="element-247" data-mp="1595l7e6edebl">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-248" data-mp="10cnj6m2gbu2y" />}
        </React.Fragment>)}
    </div>;
}